export const blockIconsAndroidSignalCellularAltNew = (
	<span className='material-symbols-outlined'>signal_cellular_alt</span>
);
